(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlsc-soap-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlsc-soap-bundle')) {
    customElements.define('tlsc-soap-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.rows = Array.from(this.querySelectorAll('[data-bundle-item]')).map(element => ({ element, id: element.dataset.variantId, name: element.dataset.productName, limit: Number(element.dataset.limit), stock: Number(element.dataset.stock), quantity: 0 }));
        this.form = this.querySelector('[data-bundle-form]');
        this.addButton = this.querySelector('[data-add-bundle]');
        this.addLabel = this.addButton.textContent;
        this.clearButton = this.querySelector('[data-clear]');
        this.progress = this.querySelector('[data-progress]');
        this.selection = this.querySelector('[data-selection]');
        this.error = this.querySelector('[data-error]');
        this.review = this.querySelector('[data-review]');
        this.busy = false;
        this.locked = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-delta]');
          if (!button || this.busy || this.locked) return;
          const row = this.rows.find(item => item.element === button.closest('[data-bundle-item]'));
          if (!row) return;
          const delta = Number(button.dataset.delta);
          if (delta > 0 && (this.total() >= 3 || row.quantity >= row.limit)) return;
          row.quantity = Math.max(0, row.quantity + delta);
          this.error.hidden = true;
          this.review.hidden = true;
          this.update();
        });
        this.clearButton.addEventListener('click', () => {
          if (this.busy || this.locked) return;
          this.rows.forEach(row => { row.quantity = 0; });
          this.error.hidden = true;
          this.review.hidden = true;
          this.update();
        });
        this.form.addEventListener('submit', event => this.submit(event));
        if (window.location.hash === '#BuildSoapBundle') this.closest('details').open = true;
        this.update();
      }

      total() { return this.rows.reduce((sum, row) => sum + row.quantity, 0); }

      update() {
        const count = this.total();
        this.progress.textContent = this.dataset.countTemplate.replace('__count__', String(count));
        this.rows.forEach(row => {
          row.element.querySelector('[data-quantity]').textContent = String(row.quantity);
          row.element.querySelector('[data-delta="-1"]').disabled = this.busy || this.locked || row.quantity === 0;
          row.element.querySelector('[data-delta="1"]').disabled = this.busy || this.locked || count >= 3 || row.quantity >= row.limit;
        });
        this.selection.replaceChildren();
        const selected = this.rows.filter(row => row.quantity > 0);
        if (selected.length === 0) {
          const item = document.createElement('li');
          item.textContent = this.dataset.emptySelection;
          this.selection.append(item);
        } else {
          selected.forEach(row => {
            const item = document.createElement('li');
            item.textContent = `${row.name} × ${row.quantity}`;
            this.selection.append(item);
          });
        }
        this.clearButton.disabled = this.busy || this.locked || count === 0;
        this.addButton.disabled = this.busy || this.locked || count !== 3;
        this.addButton.textContent = this.busy ? this.dataset.adding : this.addLabel;
        this.setAttribute('aria-busy', String(this.busy));
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy || this.locked || this.total() !== 3) return;
        this.busy = true;
        this.error.hidden = true;
        this.review.hidden = true;
        this.update();
        let postStarted = false;
        try {
          const cartResponse = await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error(this.dataset.beforeAddError);
          const cart = await cartResponse.json();
          const chosen = this.rows.filter(row => row.quantity > 0);
          for (const row of chosen) {
            const inCart = cart.items.filter(item => String(item.variant_id) === row.id).reduce((sum, item) => sum + item.quantity, 0);
            if (row.stock >= 0 && inCart + row.quantity > row.stock) throw new Error(this.dataset.stockError);
          }
          postStarted = true;
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: chosen.map(row => ({ id: row.id, quantity: row.quantity })) }) });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(this.dataset.afterAddError);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.locked = postStarted;
          this.error.textContent = postStarted ? this.dataset.afterAddError : error.message === this.dataset.stockError ? this.dataset.stockError : this.dataset.beforeAddError;
          this.error.hidden = false;
          this.review.hidden = false;
          this.busy = false;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
